const url = 'https://staging.quotetrack.com';
export const environment = {
    BASE_HREF: '/app',
    API_LOCATION: `${url}`,
    GRAPHQL_API: `${url}/graphql`,
    PUSHER_API_KEY: '2b09ea8f7dad0255e76d',
    PUSHER_CLUSTER: 'us2',
    PUSHER_AUTH_EP: `${url}/graphql/subscriptions/auth`,
    FEATURE_EMULATE_USER: true
};
